import { AnyObject } from '@triare/auth-redux';

export interface GeneralSettingsFormProps {
  maintenance: MaintenanceProps;
  dashboardBanner: DashboardBannerProps;
  footer: AnyObject;
}

/** Maintenance */
export interface MaintenanceProps {
  reason?: string;
  description?: string;
  active?: boolean;
}

/** Optional banner >>> */

export type DashboardBannerType = 'info' | 'warning';

export enum DashboardBannerEnum {
  info = 'Info',
  warning = 'Warning',
}

export interface DashboardBannerProps { // extends Record<HeaderKeys, HeaderItemProps>
  text?: string;
  type?: DashboardBannerType;
  visible?: boolean;
}
